import * as React from "react"
const SvgAbTesting = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.286q-1.275 0-1.813-1.138-.537-1.137.263-2.112L9 11.286v-6H8a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 4.286a.97.97 0 0 1 .287-.713A.97.97 0 0 1 8 3.286h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288h-1v6l5.55 6.75q.8.975.262 2.112-.537 1.138-1.812 1.138zm0-2h14l-6-7.3v-6.7h-2v6.7z" />
  </svg>
)
export default SvgAbTesting
